import { Component, ViewEncapsulation } from '@angular/core';
@Component(
    {
        selector: 'info',
        templateUrl: 'info.component.html',
        styleUrls: ['info.component.scss'],
        encapsulation: ViewEncapsulation.None
    }
)
export class InfoComponent
{
    public constructor()
    {

    }
}
